export default "__VITE_ASSET__Py8paDAC__"